import root from './_root';

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

export default Uint8Array;



//////////////////
// WEBPACK FOOTER
// ../ckeditor5-utils/src/lib/lodash/_Uint8Array.js
// module id = null
// module chunks = 